<app-carousel [typeSearch]="'Shop'"></app-carousel>
<div class="body-app mt-3 mb-3">
    <div class="content-app">
        <br />
        <div class="text-start">
            <nav style="--bs-breadcrumb-divider: url(&#34;data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='%236c757d'/%3E%3C/svg%3E&#34;);" aria-label="breadcrumb">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item"><a [routerLink]="['/home/shop']">Tienda</a></li>
                    <li class="breadcrumb-item"><a [routerLink]="['/home/shop']">Computadoras</a></li>
                    <li class="breadcrumb-item active" aria-current="page">Laptop HP Elite i7 11800H</li>
                </ol>
            </nav>
        </div>
        <div class="row mt-2 mb-2">
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <img src="assets/Images/product-3.jpeg" class="img-fluid" alt="Foto" />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <h5 class="mt-2 mb-1 text-primary">
                    Computadoras
                </h5>
                <h2 class="mt-0 mb-2">
                    Laptop HP Elite i7 11800H
                </h2>
                <p class="text-justify">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. In culpa, temporibus architecto quasi nostrum quaerat placeat veritatis reprehenderit voluptatum autem nihil accusantium excepturi esse, fugit dolor possimus sit quisquam velit!
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. In culpa, temporibus architecto quasi nostrum quaerat placeat veritatis reprehenderit voluptatum autem nihil accusantium excepturi esse, fugit dolor possimus sit quisquam velit!
                </p>
                <div class="table-responsive">
                    <table class="table">
                        <tbody>
                            <tr>
                                <td class="text-start">
                                    <strong>Caracteristicas</strong>
                                </td>
                                <td class="text-end">
                                    Descripcion de caracteristicas
                                </td>
                            </tr>
                            <tr>
                                <td class="text-start">
                                    <strong>Caracteristicas</strong>
                                </td>
                                <td class="text-end">
                                    Descripcion de caracteristicas
                                </td>
                            </tr>
                            <tr>
                                <td class="text-start">
                                    <strong>Caracteristicas</strong>
                                </td>
                                <td class="text-end">
                                    Descripcion de caracteristicas
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-4 col-sm-12 col-12">
                        <div class="form-group mb-3">
                            <label>Cantidad</label>
                            <div>
                                <input type="number" min="0" step="1" class="form-control" />
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-8 col-sm-12 col-12">
                        <div class="mt-button">
                            <button type="button" class="btn btn-secondary me-2">
                                <i class="fa-solid fa-plus"></i>
                                Agregar
                            </button>
                            <button type="button" class="btn btn-primary">
                                <i class="fa-solid fa-cart-shopping"></i>
                                Comprar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <h5 class="mt-2 mb-2">
            <i class="fa-solid fa-store"></i>
            Productos relacionados
        </h5>
        <div class="row">
            <ng-container *ngFor="let item of products">
                <div class="col-xl-3 col-lg-4 col-md-4 col-sm-6 col-12">
                    <a [routerLink]="['/home/shop-detail']" class="text-decoration-none">
                        <div class="card card-shop mb-3">
                            <div class="card-img-top">
                                <img [src]="item.foto" class="img-fluid" alt="foto" />
                            </div>
                            <div class="card-body position-relative">
                                <h6 class="mt-2 mb-0 text-primary">
                                    {{ item.description }}
                                </h6>
                                <p class="mt-0 mb-0 text-left">
                                    {{ item.comment.substring(0, 55) + '...' }}
                                </p>
                                <span class="shop-price">
                                    {{ item.price }}
                                </span>
                                <span class="shop-off" *ngIf="item.off != ''">
                                    {{ item.off }}
                                </span>
                            </div>
                        </div>    
                    </a>
                </div>
            </ng-container>
        </div>
    </div>
</div>